module.exports = __webpack_public_path__ + "static/media/flutter-logo.c3e79efb.svg";